export default __webpack_public_path__ + "static/media/leaf_icon.a134eec9.jpeg";